import { type FC } from 'react';

import {
  useGetArenaOffersQuery,
  useGetShopInfoQuery,
} from '@/api/queries/shop';
import { useGetVipInfoQuery } from '@/api/queries/user';
import { useAppSelector } from '@/redux/store';

import ArenaOffers from './ArenaOffers/ArenaOffers';
import BoxMarket from './BoxMarket/BoxMarket';
import { VipMarket } from './VipMarket/VipMarket';

const OffersMarket: FC = () => {
  const vipData = useAppSelector((state) => state.user.vip);
  useGetVipInfoQuery();
  useGetShopInfoQuery();
  useGetArenaOffersQuery();

  return (
    <div className="flex flex-col w-full px-4 pt-5 gap-6">
      <ArenaOffers />
      {vipData && <VipMarket />}
      <BoxMarket />
    </div>
  );
};

export { OffersMarket };
